import React, { forwardRef } from "react";
import { BSHeading } from "../../types";

export const DropdownHeader = forwardRef<HTMLHeadingElement, BSHeading>(
  ({ children, component: Component = "h6", ...props }, ref) => (
    <Component {...props} className="dropdown-header" ref={ref}>
      {children}
    </Component>
  )
);